export default __webpack_public_path__ + "static/media/tickandarrow.d0148367.svg";